
<!--
 * @Description: 教职工详情 学历学位
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:33:44
-->
<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
        <el-descriptions-item label="入学年月" label-align="right" align="left" width="140px" span="2">{{item.rxny}}</el-descriptions-item>
        <el-descriptions-item label="学制" label-align="right" align="left" width="140px" span="2">{{item.xz}}</el-descriptions-item>
        <el-descriptions-item label="学习方式" label-align="right" align="left" span="2">{{item.xxfsbt}}</el-descriptions-item>
        <el-descriptions-item label="学习形式" label-align="right" align="left" span="2">{{item.xxxsbt}}</el-descriptions-item>
        <el-descriptions-item label="学历" label-align="right" align="left" span="2">{{item.xlbt}}</el-descriptions-item>
        <el-descriptions-item label="所学专业" label-align="right" align="left" span="2">{{item.sxzy}}</el-descriptions-item>
        <el-descriptions-item label="结束学业年月" label-align="right" align="left" span="2">{{item.jsxyny}}</el-descriptions-item>
        <el-descriptions-item label="毕肄业学校或单位" label-align="right" align="left" span="2">{{item.byyxxhdw}}</el-descriptions-item>
        <el-descriptions-item label="学历证书号" label-align="right" align="left" span="2">{{item.xlzsh}}</el-descriptions-item>
        <el-descriptions-item label="获得学位" label-align="right" align="left" span="2">{{item.hdxwbt}}</el-descriptions-item>
        <el-descriptions-item label="授学位单位名称" label-align="right" align="left" span="2">{{item.sxwdwmc}}</el-descriptions-item>
        <el-descriptions-item label="授学位国家/地区" label-align="right" align="left" span="2">{{item.sxwgjdqbt}}</el-descriptions-item>
        <el-descriptions-item label="获学位专业码" label-align="right" align="left" span="2">{{item.hxwzym}}</el-descriptions-item>
        <el-descriptions-item label="获学位日期" label-align="right" align="left" span="2">{{item.hxwrq}}</el-descriptions-item>
        <el-descriptions-item label="学位证书号" label-align="right" align="left" span="4">{{item.xwzsh}}</el-descriptions-item>
        <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
      </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongxuelixuewei/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
